import { aboutMeEN } from "./aboutMeEN";
import { aboutMeDE } from "./aboutMeDE";
import { experiencesEN } from "./experiencesEN";
import { experiencesDE } from "./experiencesDE";
import { skillsEN } from "./skillsEN";
import { skillsDE } from "./skillsDE";
export { projects } from "./projects";
export { translations } from "./translations";
export { links } from "./links";

export const aboutMeTranslations = {
  EN: aboutMeEN,
  DE: aboutMeDE,
};

export const experiencesTranslations = {
  EN: experiencesEN,
  DE: experiencesDE,
};

export const skillsTranslations = {
  EN: skillsEN,
  DE: skillsDE,
};
